import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Breadcrumbs from "../based/Breadcrumbs";
import CommonTable from "../based/CommonTable";
import { INITPAGING, NOTIFY } from "../based/Constants";
import { ConfirmDialog } from "../based/Dialog";
import CheckBox from "../based/inputs/CheckBox";
import Loading from "../based/Loading";
import { Notify } from "../based/Notify";
import CustomizeServices from "../based/services/CustomizeServices";
import AddOrEditModal from "./AddOrEditModal";
import AddMultipleModal from "./AddOrEditMultipleModal";

const StockImageModel = {
    id: 0,
    title: "",
    thumbUrl: "",
    width: 0,
    height: 0,
    shutterStockId: "",
};

function StockImage(props) {
    const [isBusy, setIsBusy] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [msg, setMsg] = useState("Đang tải...");
    const [datas, setDatas] = useState([StockImageModel]);
    const [paging, setPaging] = useState({ ...INITPAGING });
    const [isShowModal, setIsShowModal] = useState(false);
    const [isShowMultiModal, setIsShowMultiModal] = useState(false);
    const [selectId, setSelectId] = useState(0);

    useEffect(() => {
        _getData({ ...INITPAGING, pageNumber: 1, pageSize: 50 });
    }, []);

    async function _getData(paging) {
        setIsBusy(true);
        let [err, data] = await CustomizeServices.GetStockImagePaging(paging);
        if (!err && data) {
            setDatas(data.listObjects);
            setPaging(data.paging);
        } else {
            setDatas([]);
            setPaging({ ...INITPAGING });
        }
        setIsBusy(false);
    }

    const _handleChecked = (index, value) => {
        let newDatas = [...datas];
        if (value) setSelectId(newDatas[index].id);
        else setSelectId(0);
    };

    const _handleDelete = async (id) => {
        ConfirmDialog("Xác nhận xóa?", "Xin vui lòng xác nhận để xóa ", () => {
            return new Promise(async (resolve, reject) => {
                setIsLoading(true);
                setMsg("Đang xóa dữ liệu...");
                let [error, data] = await CustomizeServices.DeleteStockImage(id);
                if (!error && data) {
                    _getData(paging);
                    resolve({ title: "Thành công", msg: "Xóa thành công." });
                } else {
                    Notify(NOTIFY.WARNING, "Có lỗi", "Có lỗi xảy ra trong quá trình xóa.");
                    reject({ title: "Thất bại", msg: "Vui lòng thử lại sau." });
                }
                setMsg(null);
                setIsLoading(false);
            });
        });
    };

    function _renderHeader() {
        return (
            <thead>
                <tr>
                    <th className="center"></th>
                    <th className="center">Title</th>
                    <th className="center">Thumbnail</th>
                    <th className="center">Tags</th>
                    <th className="center">Id các sàn</th>
                    <th className="center">Thông tin</th>
                    <th className="center">Hành động</th>
                </tr>
            </thead>
        );
    }

    function _renderAction() {
        let dataChecked = null;
        let isEnabled = false;
        if (datas && datas.length > 0) {
            dataChecked = datas.filter((x) => x.selected);
            if (dataChecked && dataChecked.length == 1) isEnabled = true;
        }
        return (
            <React.Fragment>
                <button
                    className="btn btn-custom"
                    onClick={() => {
                        setIsShowModal(true);
                        setSelectId(0);
                    }}
                >
                    Thêm mới
                </button>
                <button
                    className="btn btn-custom mx-2"
                    onClick={() => {
                        setIsShowMultiModal(true);
                        setSelectId(0);
                        setIsShowModal(false);
                    }}
                >
                    Thêm mới hàng loạt
                </button>
                <button className={selectId > 0 ? "btn btn-danger ml-3" : "btn btn-danger ml-3 disable"} onClick={() => (selectId > 0 ? _handleDelete(selectId) : {})}>
                    Xóa
                </button>
            </React.Fragment>
        );
    }

    function _renderBody() {
        return (
            <tbody>
                {datas && datas.length > 0 ? (
                    datas.map((item, idx) => {
                        return (
                            <tr className={idx}>
                                <td>
                                    <CheckBox id={idx.toString()} name={idx.toString()} checked={item.id ? item.id == selectId : false} label=" " onCheckedChange={(name, value) => _handleChecked(idx, value)} />
                                </td>
                                <td>{item.title}</td>
                                <td>
                                    <img
                                        src={item.thumbUrl}
                                        alt={item.title}
                                        style={{
                                            width: "100px",
                                            height: "100px",
                                            objectFit: "contain",
                                        }}
                                    />
                                </td>
                                <td>
                                    {item.tagConnections &&
                                        item.tagConnections.map((ele, i) => {
                                            return (
                                                <span key={i} className="badge badge-custom m-2">
                                                    {ele}
                                                </span>
                                            );
                                        })}
                                </td>
                                <td>{item.stockImagePlatform && `${item.stockImagePlatform.platformId} - ${item.stockImagePlatform.platformTypeName}`}</td>
                                <td>
                                    Width: {item.width}px <br />
                                    Height: {item.height}px
                                </td>
                                <td>
                                    <button
                                        className="btn btn-custom"
                                        onClick={() => {
                                            setIsShowModal(true);
                                            setSelectId(item.id);
                                        }}
                                    >
                                        Chi tiết
                                    </button>
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan={999}>Không có dữ liệu</td>
                    </tr>
                )}
            </tbody>
        );
    }

    return (
        <Wrapper>
            <Loading show={isBusy} msg="Đang tải dữ liệu..." />
            <Breadcrumbs currentPage="Quản lý Stock Photo" />
            <CommonTable datas={datas} paging={paging} searchBasic onFilter={(paging) => _getData(paging)} renderAction={() => _renderAction()} renderHeader={() => _renderHeader()} renderBody={() => _renderBody()} />
            {isShowModal && (
                <AddOrEditModal
                    isShowModal={isShowModal}
                    onClose={() => {
                        setIsShowModal(false);
                        setSelectId(0);
                    }}
                    onSaveContinue={() => {
                        setIsShowModal(false);
                        _getData({ ...paging });
                    }}
                    id={selectId}
                />
            )}
            {isShowMultiModal && (
                <AddMultipleModal
                    isShowModal={isShowMultiModal}
                    onClose={() => {
                        setIsShowMultiModal(false);
                    }}
                    onSaveContinue={() => {
                        setIsShowMultiModal(false);
                        _getData({ ...paging });
                    }}
                />
            )}
        </Wrapper>
    );
}

export default StockImage;

function ScanString(fileName) {}

const Wrapper = styled.div`
    .modal-class-body {
        min-height: 50vh;
    }
`;
